export const ON_NAVIGATION_REQUEST = 'ON_NAVIGATION_REQUEST';
export const EMPTY_PAYLOAD = 'EMPTY_PAYLOAD';
export const REGISTER_NAVIGATION_VIEWS = 'REGISTER_NAVIGATION_VIEWS';
export const ON_NAVIGATION_LOAD_SUCCESS = 'ON_NAVIGATION_LOAD_SUCCESS';
export const NAVIGATION_LOAD_FAILURE = 'NAVIGATION_LOAD_FAILURE';
export const BEGIN_NAVIGATION_BINDING = 'BEGIN_NAVIGATION_BINDING';

export const BEGIN_NAVIGATION_LOAD = 'BEGIN_NAVIGATION_LOAD';
export const initializeNavigationItems = state => (dispatch) => {
  const { authentication, } = state.auth;

  return dispatch({
    type: BEGIN_NAVIGATION_LOAD,
    loadNavigationItems: (executor) => {
      executor(authentication)
        .then((res) => {
          const { data, } = res;
          const { items = [], } = data;
          dispatch({
            type: ON_NAVIGATION_LOAD_SUCCESS,
            raw: items,
          });
          dispatch({
            type: BEGIN_NAVIGATION_BINDING,
          });
        })
        .catch((res) => {
          const { response = {}, } = res;
          const {
            data = {
              errors: [ 'Unable to load navigation items', ],
            },
          } = response;

          dispatch({
            type: NAVIGATION_LOAD_FAILURE,
            data,
          });
        });
    },
  });
};
